import React from 'react';
import { Window } from 'styles/Window';
import { useTitle } from 'hookrouter';

const Works= () => {
  useTitle("YTH's Works");

  return (
    (
    <Window>
      <p className="pagetitle">Works</p>
      <p>My projects/releases can be found here.</p>
      <p className="title">Publications</p>
      <em>Working on it!</em>
      <p className="title">Github</p>
      <a href="http://github.com/yiktungho">Github Profile</a>
      <p className="title">Host and Contributor to S. G. Productions</p>
      <p>Misc projects (NES chiptunes, watchfaces, etc.) at this <a href="http://sgproductions.github.io/console">website</a>.</p>
    </Window>
    )
  )
};

export default Works;
